import { infoFetchEspecialidadI, makeEspecialidad } from "dtos/especialidad";
import { ENDPOINTS } from "./endpoints";
import {
  FetchCallbackI,
  getResponseWithPagination,
} from "./request/request.interface";
import { sendRequest } from "./request/request.service";
import { servicesUtils } from "./utils/services.utils";

export const getEspecialidades = async (params: any) => {
  const response = await sendRequest<
    getResponseWithPagination<infoFetchEspecialidadI>
  >({
    method: "GET",
    uri: ENDPOINTS.ESPECIALIDAD,
    params: servicesUtils.removeNullParamsInFilters(params),
  });

  const elementosFormated = response.elementos.map((ctElemento) =>
    makeEspecialidad(ctElemento),
  );
  return {
    ...response,
    elementos: elementosFormated,
  };
};

export const postEspecialidad = async ({ params, images }: FetchCallbackI) => {
  const response = await sendRequest<infoFetchEspecialidadI>({
    method: "POST",
    uri: ENDPOINTS.ESPECIALIDAD,
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return makeEspecialidad(response);
};

export const putEspecialidad = async ({ params, images }: FetchCallbackI) => {
  const response = await sendRequest<infoFetchEspecialidadI>({
    method: "PUT",
    uri: ENDPOINTS.ESPECIALIDAD,
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return makeEspecialidad(response);
};

export const deleteEspecialidad = async (id: any) => {
  await sendRequest({
    method: "DELETE",
    uri: ENDPOINTS.ESPECIALIDAD + "/" + id,
  });
};
